export default () => ({
  source: '',
  directRedirect: false,
})
